/* eslint-disable */
/**
 * SPA
 * API serving data for the SPA
 *
 * The version of the OpenAPI document is present in runtime.ts
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * Optional precision, for numeric properties
 * @export
 * @interface Precision
 */
export interface Precision {
    /**
     * 
     * @type {number}
     * @memberof Precision
     */
    fractionalDigits?: number;
    /**
     * 
     * @type {number}
     * @memberof Precision
     */
    integerDigits: number;
}

/**
 * Check if a given object implements the Precision interface.
 */
export function instanceOfPrecision(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "integerDigits" in value;

    return isInstance;
}

export function PrecisionFromJSON(json: any): Precision {
    return PrecisionFromJSONTyped(json, false);
}

export function PrecisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Precision {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fractionalDigits': !exists(json, 'fractionalDigits') ? undefined : json['fractionalDigits'],
        'integerDigits': json['integerDigits'],
    };
}

export function PrecisionToJSON(value?: Precision | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'fractionalDigits': value.fractionalDigits,
        'integerDigits': value.integerDigits,
    };
}

